import { render, staticRenderFns } from "./AddEventModal.vue?vue&type=template&id=9054c110&scoped=true&"
import script from "./AddEventModal.vue?vue&type=script&lang=js&"
export * from "./AddEventModal.vue?vue&type=script&lang=js&"
import style0 from "./AddEventModal.vue?vue&type=style&index=0&id=9054c110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9054c110",
  null
  
)

export default component.exports